export default __webpack_public_path__ + "static/media/horde-attack.65c27ff8.png";